import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default ({
  value = '', onChange = (e) => e, label = '', error = '', helpText, ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <>
      <TextField
        label={label}
        margin="normal"
        variant="outlined"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={!!error}
        helperText={error || helpText}
        InputProps={{ // <-- This is where the toggle button is added.
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                style={{ padding: '10px', marginTop: 0 }}
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                size="large"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...props}
        type={showPassword ? 'text' : 'password'}
      />
    </>
  );
};
